module.exports = __webpack_public_path__ + "static/media/manu-9.1ea20cf9.png";